import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap"
import { FaPlus, FaX } from "react-icons/fa6"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Configs from "../../config"
import countryList from "react-select-country-list"
import Select from "react-select"
import { customStyles } from "utils/SelectStyles"

const AddUser = () => {
  const navigate = useNavigate()

  const [clubData, setClubData] = useState([])
  const [planData, setPlanData] = useState([])
  const [loading, setloading] = useState(false)
  const [countryOptions, setCountryOptions] = useState([])
  const [errors, setErrors] = useState({})

  useEffect(() => {
    getClubs()
    setCountryOptions(countryList().getData())
  }, [])

  async function getClubs() {
    const APIData2 = await fetchData(setloading, "pricing/plan")
    const APIdata = await fetchData(setloading, "club")

    setPlanData(
      APIData2.userPlans?.map(item => ({
        label: item?.planName,
        value: item?._id,
      }))
    )

    setClubData(
      APIdata?.clubs?.map(item => ({
        label: item?.clubName,
        value: item?._id,
      }))
    )
  }

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    club: "",
    birthdate: "",
    gender: "",
    country: "",
    postcode: "",
    trainingStartDate: "",
    plan: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" })) // clear field error on change
  }

  const handleCountryChange = selected => {
    setFormData(prev => ({
      ...prev,
      country: selected?.value || "",
    }))
    setErrors(prev => ({ ...prev, country: "" }))
  }

  // 🔹 VALIDATION LOGIC
  const validateForm = () => {
    const newErrors = {}
    if (!formData.name.trim()) newErrors.name = "Name is required."
    if (!formData.email.trim()) newErrors.email = "Email is required."
    else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(formData.email))
        newErrors.email = "Enter a valid email address."
    }
    if (!formData.club) newErrors.club = "Club selection is required."
    if (!formData.birthdate) newErrors.birthdate = "Birthdate is required."
    if (!formData.gender) newErrors.gender = "Please select gender."
    if (!formData.plan) newErrors.plan = "Please select a plan."
    if (!formData.trainingStartDate)
      newErrors.trainingStartDate = "Training start date is required."
    if (!formData.country) newErrors.country = "Country is required."
    if (!formData.postcode.trim()) newErrors.postcode = "Postcode is required."

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validateForm()) return

    const APIData = await FetchPostData(setloading, "user/by/admin", formData)

    if (APIData?.data?.success) {
      Swal.fire({
        title: "User Created Successfully.",
        icon: "success",
      })
      navigate(`${Configs.appurl}users`)
    } else {
      Swal.fire({
        title: "Something went wrong",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  // 🔹 FIELD LABEL COMPONENT (adds * automatically)
  const FieldLabel = ({ label }) => (
    <Label>
      {label} <span className="text-danger">*</span>
    </Label>
  )

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="Users" breadcrumbItem="Add User" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Add User</h4>
                  <div className="d-flex gap-3">
                    <button className="btn btn-add" onClick={handleSubmit}>
                      <FaPlus className="me-1" size={14} />
                      Submit
                    </button>
                    <button
                      className="btn bg-danger text-white"
                      onClick={() => navigate(-1)}
                    >
                      <FaX className="me-1" size={14} />
                      Cancel
                    </button>
                  </div>
                </div>

                <div className="Seprator" />

                <Row className="mt-4">
                  {/* Name */}
                  <Col md="4">
                    <FieldLabel label="Name" />
                    <Input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter full name"
                      invalid={!!errors.name}
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </Col>

                  {/* Email */}
                  <Col md="4">
                    <FieldLabel label="Email" />
                    <Input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                      invalid={!!errors.email}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </Col>

                  {/* Club */}
                  <Col md="4">
                    <FieldLabel label="Select Club" />
                    <Input
                      type="select"
                      name="club"
                      value={formData.club}
                      onChange={handleChange}
                      invalid={!!errors.club}
                    >
                      <option value="">Select Club</option>
                      {clubData.map(club => (
                        <option key={club.value} value={club.value}>
                          {club.label}
                        </option>
                      ))}
                    </Input>
                    {errors.club && (
                      <small className="text-danger">{errors.club}</small>
                    )}
                  </Col>
                </Row>

                <Row className="mt-4">
                  {/* Birthdate */}
                  <Col md="4">
                    <FieldLabel label="Birth Date" />
                    <Input
                      type="date"
                      name="birthdate"
                      value={formData.birthdate}
                      onChange={handleChange}
                      invalid={!!errors.birthdate}
                    />
                    {errors.birthdate && (
                      <small className="text-danger">{errors.birthdate}</small>
                    )}
                  </Col>

                  {/* Gender */}
                  <Col xl="4">
                    <FieldLabel label="Gender" />
                    <Input
                      type="select"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      invalid={!!errors.gender}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="nonbinary">Non-Binary</option>
                      <option value="prefer_not_say">Prefer not to say</option>
                      <option value="other">Other</option>
                    </Input>
                    {errors.gender && (
                      <small className="text-danger">{errors.gender}</small>
                    )}
                  </Col>

                  {/* Plan */}
                  <Col xl="4">
                    <FieldLabel label="Plan" />
                    <Input
                      type="select"
                      name="plan"
                      value={formData.plan}
                      onChange={handleChange}
                      invalid={!!errors.plan}
                    >
                      <option value="">Select Plan</option>
                      {planData.map(plan => (
                        <option key={plan.value} value={plan.value}>
                          {plan.label}
                        </option>
                      ))}
                    </Input>
                    {errors.plan && (
                      <small className="text-danger">{errors.plan}</small>
                    )}
                  </Col>
                </Row>

                <Row className="mt-4">
                  {/* Training Start Date */}
                  <Col md="4">
                    <FieldLabel label="Training Start Date" />
                    <Input
                      type="date"
                      name="trainingStartDate"
                      value={formData.trainingStartDate}
                      onChange={handleChange}
                      invalid={!!errors.trainingStartDate}
                    />
                    {errors.trainingStartDate && (
                      <small className="text-danger">
                        {errors.trainingStartDate}
                      </small>
                    )}
                  </Col>

                  {/* Country */}
                  <Col md="4">
                    <FieldLabel label="Country" />
                    <Select
                      options={countryOptions}
                      value={
                        countryOptions.find(
                          option => option.value === formData.country
                        ) || null
                      }
                      styles={customStyles}
                      onChange={handleCountryChange}
                      placeholder="Select Country"
                    />
                    {errors.country && (
                      <small className="text-danger">{errors.country}</small>
                    )}
                  </Col>

                  {/* Postcode */}
                  <Col md="4">
                    <FieldLabel label="PostCode" />
                    <Input
                      type="text"
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleChange}
                      placeholder="Enter PostCode"
                      invalid={!!errors.postcode}
                    />
                    {errors.postcode && (
                      <small className="text-danger">{errors.postcode}</small>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AddUser
